import script from "./tab-advice.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-advice.vue?vue&type=script&setup=true&lang=js"

import "./tab-advice.vue?vue&type=style&index=0&id=27a7387c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a7387c"]])

export default __exports__